const znxjjc = [{
    path: 'znxjjc_xjrw',
    name: 'znxjjc_xjrw',
    component: () =>
      import('@/components/znxjjc/xjrw'),
    meta: {title: '巡检任务', requireAuth: true, keepAlive: true, permission: true}
  },
  {
    path: 'znxjjc_xjjl',
    name: 'znxjjc_xjjl',
    component: () =>
        import('@/components/znxjjc/xjjl'),
    meta: {title: '巡检记录', requireAuth: true, keepAlive: true, permission: true}
  },
  {
    path: 'znxjjc_bzgl',
    name: 'znxjjc_bzgl',
    component: () =>
        import('@/components/znxjjc/bzgl'),
    meta: {title: '班组管理', requireAuth: true, keepAlive: true, permission: true}
  },
  {
    path: 'znxjjc_xjd',
    name: 'znxjjc_xjd',
    component: () =>
        import('@/components/znxjjc/xjd'),
    meta: {title: '巡检点', requireAuth: true, keepAlive: true, permission: true}
  },
  {
    path: 'znxjjc_xjlx',
    name: 'znxjjc_xjlx',
    component: () =>
        import('@/components/znxjjc/xjlx'),
    meta: {title: '巡检路线', requireAuth: true, keepAlive: true, permission: true}
  },
  {
    path: 'znxjjc_xjjls',
    name: 'znxjjc_xjjls',
    component: () =>
        import('@/components/znxjjc/xjjls'),
    meta: {title: '巡检记录', requireAuth: true, keepAlive: true, permission: true}
  },
  {
    path: 'znxjjc_rwjm',
    name: 'znxjjc_rwjm',
    component: () =>
        import('@/components/znxjjc/rwjm'),
    meta: {title: '未巡检记录', requireAuth: true, keepAlive: true, permission: true}
  }
  ]
  export default znxjjc


// WEBPACK FOOTER //
// ./src/router/znxjjc.js